import { render, staticRenderFns } from "./SupplierInvoices.vue?vue&type=template&id=2963bae1&lang=pug&"
import script from "./SupplierInvoices.vue?vue&type=script&lang=js&"
export * from "./SupplierInvoices.vue?vue&type=script&lang=js&"
import style0 from "./SupplierInvoices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports